module.exports = __webpack_public_path__ + "src/assets/img/card-shirt.4bc39678.svg";